import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import { AppProvider } from './context/AppContext';
import './index.css';
import { AxiosProvider } from './context/AxiosContext';
import { App, KonstaProvider } from 'konsta/react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Store from './pages/Store';
import ProfilePage from './pages/ProfilePage';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import ProductPage from './pages/ProductPage';
import OrderPage from './pages/OrderPage';
import MyMinersPage from './pages/MyMinersPage';
import MyMinerDetailsPage from './pages/MyMinerDetailsPage';
import BrowserNotSupportedPage from './pages/BrowserNotSupportedPage';
import ReferralPage from './pages/ReferralPage';
import WithdrawPage from './pages/WithdrawPage';
import { Navigate, Outlet } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import TransactionsPage from './pages/TransactionsPage';
import TopMinersPage from './pages/TopMinersPage';
import HowPage from './pages/HowPage';
import { isTMA } from '@telegram-apps/sdk';

const queryClient = new QueryClient();

const EnsureTelegramRoute = () => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);

  useEffect(() => {
    const checkAuthentication = async () => {
      try {
        const isOpenedInTelegram = await isTMA(); // Assuming this can be async
        setIsAuthenticated(isOpenedInTelegram);
      } catch {
        setIsAuthenticated(false);
      }
    };

    checkAuthentication();
  }, []);

  if (isAuthenticated === null) {
    return <div>Loading...</div>; // Show loading state
  }

  return isAuthenticated ? <Outlet /> : <Navigate to="/landing" replace />;
};

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <KonstaProvider theme="material" dark>
      <QueryClientProvider client={queryClient}>
        <AppProvider>
          <AxiosProvider>
            <App safeAreas dark theme="material" className="k-material">
              <Router>
                <Routes>
                  <Route path="/landing" element={<LandingPage />} />
                  <Route element={<EnsureTelegramRoute />}>
                    <Route path="/" element={<Home />} />
                    <Route path="store" element={<Store />} />
                    <Route path="how" element={<HowPage />} />
                    <Route path="transactions" element={<TransactionsPage />} />
                    <Route path="top-miners" element={<TopMinersPage />} />
                    <Route
                      path="product/:productId/:userProductId?"
                      element={<ProductPage />}
                    />
                    <Route path="order/:orderId" element={<OrderPage />} />
                    <Route path="my-miners" element={<MyMinersPage />} />
                    <Route
                      path="my-miners/:productId"
                      element={<MyMinerDetailsPage />}
                    />
                    <Route path="profile" element={<ProfilePage />} />
                    <Route
                      path="unsupported-browser"
                      element={<BrowserNotSupportedPage />}
                    />
                    <Route path="referrals" element={<ReferralPage />} />
                    <Route path="withdraw" element={<WithdrawPage />} />
                  </Route>
                </Routes>
              </Router>
            </App>
          </AxiosProvider>
        </AppProvider>
      </QueryClientProvider>
    </KonstaProvider>
  </React.StrictMode>,
);
